import { render, staticRenderFns } from "./ShopGuide.vue?vue&type=template&id=679baac6"
import script from "./ShopGuide.vue?vue&type=script&lang=js"
export * from "./ShopGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports